module.exports = __webpack_public_path__ + "images/graphic-header-mobile@2x_e35be5a40f0c68c550aa92a46b7a304e.png";